import templateWorkflowStageDelete from './workflowStageDelete.template.html';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $stateParams,
  $filter,
  $timeout,
  $interval,
  $mdDialog,
  webpage,
  authenticationService,
  eventService,
  changesService,
  uiService,
  workflowService,
  workflowsService,
  workflowEditService,
  accountsService,
  checklistsService,
  jobTypesService,
  messagesService,
  documentsService,
  ticketsService,
  Workflow,
  WorkflowType,
  WorkflowStage,
  ACCOUNT
) => {
  $scope.Model = {
    parentWorkflow: {},
    currentWorkflow: {},
    availableWorkflows: [],
    availableAccounts: [],
    availableJobTypes: [],
    availableChecklists: [],
    availableMessages: [],
    availableDocuments: [],
    editorVisible: {
      isMilestoneIsFactFindEditable: false,
      probabilityRottingAfter: false
    },
    stageHeight: null,
    completedInitialization: false,
    isReady: false
  };

  $rootScope.$on('$stateChangeStart', function (ev, toState, toParams) {
    $scope.Model.toState = toState;
    $scope.Model.toParams = toParams;
  });

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Stage Movement Options
   * --------------------------------------------------------------------------------
   */
  $scope.stageSortingOptions = {
    placeholder: 'drag-place-holder',
    connectWith: '.stage-content',
    cursor: 'move',
    opacity: 0.65,
    start: (e, ui) => {
      ui.item.show().addClass('ghost');
    },
    helper: (event, element) => {
      return $(element).clone().addClass('dragging');
    },
    update: () => {},
    stop: (e, ui) => {
      ui.item.show().removeClass('ghost');
      $scope.toggleChanges();
    }
  };

  /*
   * Event Listeners
   * --------------------------------------------------------------------------------
   */
  $scope.$on('workflowSettingsAddStage', () => {
    $scope.addStageToWorkflow();
  });

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  $scope.workflowEditorInitialize = () => {
    if (!$scope.Model.isReady) {
      workflowEditService
        .workflowEditInitialize($scope.Model.currentWorkflow, $scope.Model.availableAccounts)
        .then(() => {
          $scope.Model.stageHeight = workflowEditService.getStageHeight(
            $scope.Model.currentWorkflow
          );
          $interval(function () {
            $scope.Model.stageHeight = workflowEditService.getStageHeight(
              $scope.Model.currentWorkflow
            );
          }, 500);

          $scope.accountChipCollection = workflowEditService.transformAccountsToChips(
            $scope.Model.availableAccounts
          );
          $scope.teamMembersChipCollection = workflowEditService.transformTeamMembersToChips(
            $scope.Model.currentWorkflow.idTeamMembers,
            $scope.accountChipCollection
          );
          $scope.accountChipCollectionFilter = (query) =>
            workflowEditService.queryChips(query, $scope.accountChipCollection);
          $scope.teamMemberChipCollectionFilter = (query) =>
            workflowEditService.queryChips(query, $scope.teamMembersChipCollection);
          $scope.$watchCollection('teamMembersChipCollection', () => {
            $scope.Model.currentWorkflow.idTeamMembers = _.map(
              $scope.teamMembersChipCollection,
              'id'
            );
            $scope.toggleChanges();
          });

          $timeout(() => {
            webpage.pageTitle(`Workflow ${$scope.Model.currentWorkflow.name} : Settings`);
            if (!_.isUuid($scope.Model.currentWorkflow.id)) {
              $scope.addStageToWorkflow(3);
            }
            $scope.Model.isReady = true;
          });
          $timeout(() => {
            $scope.Model.completedInitialization = true;
          });
        });
    }
  };

  $scope.isStageDeleteable = (stage) =>
    $rootScope.CurrentOrganization.isRoot() ||
    (!$rootScope.CurrentOrganization.isRoot() && !_.isUuid(stage.idClone)) ||
    (!$rootScope.CurrentOrganization.isRoot() &&
      _.isUuid(stage.idClone) &&
      !_.find($scope.Model.parentWorkflow?.stages, { id: stage.idClone }));

  $scope.toggleEditor = ($event, editor, state) => {
    if (
      $rootScope.CurrentOrganization.isRoot() ||
      (!$rootScope.CurrentOrganization.isRoot() && authenticationService.isManager())
    ) {
      if (editor === 'isMilestoneIsFactFindEditable') {
        if (
          !$scope.Model.editorVisible.isMilestoneIsFactFindEditable ||
          state === true ||
          state === false
        ) {
          $scope.Model.editorVisible.isMilestoneIsFactFindEditable =
            state === true || state === false
              ? state
              : !$scope.Model.editorVisible.isMilestoneIsFactFindEditable;
        }
      }
    }
    if (editor === 'probabilityRottingAfter') {
      if (
        !$scope.Model.editorVisible.probabilityRottingAfter ||
        state === true ||
        state === false
      ) {
        $scope.Model.editorVisible.probabilityRottingAfter =
          state === true || state === false
            ? state
            : !$scope.Model.editorVisible.probabilityRottingAfter;
      }
    }
  };

  $scope.getStageHeight = () =>
    workflowEditService.getStageHeight($scope.Model.currentWorkflow);

  $scope.getAccount = (idAccount) =>
    _.find($scope.Model.availableAccounts, (account) =>
      idAccount instanceof Array ? idAccount.indexOf(account.id) > -1 : account.id === idAccount
    );

  $scope.addStageToWorkflow = (stagesNo) => {
    const len = parseInt(stagesNo || 1, 10);
    for (let s = 0; s < len; s += 1) {
      const stage = WorkflowStage.blank();
      stage.isNew = true;
      $scope.Model.currentWorkflow.stages.push(stage);
    }
    $scope.toggleChanges();
  };

  $scope.removeStageFromWorkflow = (stage) => {
    const sIdx = $scope.Model.currentWorkflow.stages.indexOf(stage);
    if (sIdx > -1) {
      $scope.Model.currentWorkflow.stages.splice(sIdx, 1);
      $timeout(() => {
        $scope.toggleChanges();
      }, 3500);
    }
  };

  $scope.addJobTypeToStageWithEdit = ($event, jobType, stage, isNew) => {
    const jType = jobType;
    jType.isNew = isNew;
    jType.idWorkflow = $scope.Model.currentWorkflow.id;
    eventService.jobEdit({
      event: $event,
      job: jType,
      isJob: false,
      showAccounts: true,
      showTicket: false,
      stage,
      jobTypes: [],
      accounts: workflowEditService.getTeamMembers(
        $scope.Model.availableAccounts,
        $scope.Model.currentWorkflow.idTeamMembers
      ),
      workflow: null,
      ticket: null
    });
  };

  $scope.addJobTypeToStage = (jobType, stage) => {
    const jType = jobType;
    if (!jType.isNew) {
      const idx = _.findIndex(stage.jobTypes || [], (j) => j?.id === jType?.id);
      if (idx > -1) {
        stage.jobTypes.splice(idx, 1);
        delete jType.isNew;
        $timeout(() => {
          stage.jobTypes.splice(idx, 0, jType);
          $scope.toggleChanges();
        });
      }
    } else {
      delete jType.isNew;
      $timeout(() => {
        stage.jobTypes.push(jType);
        $scope.toggleChanges();
      });
    }
  };

  $scope.deleteJobTypeFromStage = ($event, stage, jobType) => {
    stage.jobTypes.splice(stage.jobTypes.indexOf(jobType), 1);
    $scope.toggleChanges();
  };

  $scope.getChecklist = (idChecklist) =>
    _.find($scope.Model.availableChecklists, (checklist) => checklist.id === idChecklist);

  $scope.addChecklistToStage = ($event, stage, idChecklist) => {
    if (stage.idChecklists.indexOf(idChecklist) === -1) {
      stage.idChecklists.push(idChecklist);
      $scope.toggleChanges();
    }
  };

  $scope.deleteChecklistFromStage = ($event, stage, idChecklist) => {
    stage.idChecklists.splice(stage.idChecklists.indexOf(idChecklist), 1);
    $scope.toggleChanges();
  };

  $scope.getMessage = (idMessage) =>
    _.find($scope.Model.availableMessages, (message) => message.id === idMessage);

  $scope.getMessageOptionTrigger = (stage, idMessage) => {
    const op = _.find(stage.opMessages, (opt) => opt.id === idMessage);
    return !op || op.onEnter === true ? 'notifications' : 'notifications_paused';
  };

  $scope.addMessageToStageWithEdit = ($event, stage, message) => {
    eventService.messageEditTrigger({
      event: $event,
      stage,
      message
    });
  };

  $scope.addMessageToStage = (stage, message, options) => {
    const workflowStage = stage;
    if (workflowStage.idMessages.indexOf(message.id) === -1) {
      workflowStage.idMessages.push(message.id);
    }
    if (workflowStage.opMessages) {
      const opIndex = _.findIndex(workflowStage.opMessages, (o) => o.id === message.id);
      if (opIndex > -1) {
        workflowStage.opMessages.splice(opIndex, 1);
      }
    }
    if (!workflowStage.opMessages || !workflowStage.opMessages.length) {
      workflowStage.opMessages = [];
    }
    workflowStage.opMessages.push(options);
    $scope.toggleChanges();
  };

  $scope.deleteMessageFromStage = ($event, stage, idMessage) => {
    stage.idMessages.splice(stage.idMessages.indexOf(idMessage), 1);
    const optionsIndex = _.findIndex(stage.opMessages, (op) => op.id === idMessage);
    if (optionsIndex > -1) {
      stage.opMessages.splice(optionsIndex, 1);
    }
    $scope.toggleChanges();
  };

  $scope.getDocument = (idDocument) =>
    _.find($scope.Model.availableDocuments, (document) => document.id === idDocument);

  $scope.addDocumentToStage = ($event, stage, idDocument) => {
    if (stage.idDocuments.indexOf(idDocument) === -1) {
      stage.idDocuments.push(idDocument);
      $scope.toggleChanges();
    }
  };

  $scope.deleteDocumentFromStage = ($event, stage, idDocument) => {
    stage.idDocuments.splice(stage.idDocuments.indexOf(idDocument), 1);
    $scope.toggleChanges();
  };

  $scope.deleteStage = ($event, stageToDelete) => {
    if (stageToDelete.isNew === true) {
      $scope.removeStageFromWorkflow(stageToDelete);
    } else {
      ticketsService.clearCache();
      $mdDialog
        .show({
          targetEvent: $event,
          locals: {
            currentWorkflow: $scope.Model.currentWorkflow,
            currentStage: stageToDelete
          },
          template: templateWorkflowStageDelete,
          controllerAs: '$ctrl',
          controller(currentWorkflow, currentStage) {
            const self = this;
            self.isLoading = true;
            self.isProcessing = false;
            self.currentWorkflow = currentWorkflow;
            self.currentStage = currentStage;
            self.moveToStages = _.filter(
              self.currentWorkflow.stages,
              (s) => s.id !== currentStage.id
            );
            const moveToStage = self.moveToStages[0];
            self.moveToStage = moveToStage;
            self.stageTickets = [];

            ticketsService
              .getByWorkflowStage({
                idWorkflow: self.currentWorkflow.id,
                idStage: self.currentStage.id
              })
              .then((tickets) => {
                self.stageTickets = _.map(tickets, 'id');
                self.isLoading = false;
              });

            self.confirm = () => {
              if (self.stageTickets.length) {
                self.isProcessing = true;
                ticketsService
                  .changeStage({
                    idTickets: self.stageTickets,
                    idChangedStage: self.moveToStage.id
                  })
                  .then((data) => {
                    if (data.status) {
                      self.isProcessing = false;
                      $mdDialog.hide({ status: true });
                    }
                  });
              } else {
                $mdDialog.hide({ status: true });
              }
            };
            self.cancel = () => {
              $mdDialog.cancel();
            };
          }
        })
        .then((result) => {
          if (result && result.status) {
            $scope.removeStageFromWorkflow(stageToDelete);
          }
        });
    }
  };

  /*
   * Retrieve Workflow, Accounts, Jobs, Messages and Documents
   * --------------------------------------------------------------------------------
   */
  const loadWorkflowsAndAccounts = () =>
    $q
      .all([
        workflowsService.getAvailable({ isActive: true }),
        $stateParams.id === '0'
          ? null
          : workflowsService.getParent({ idWorkflow: $stateParams.id }),
        $stateParams.id === '0'
          ? Workflow.blank()
          : workflowService.readWorkflow({ id: $stateParams.id }),
        accountsService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.CHIPS })
      ])
      .then((data) => {
        $scope.Model.availableWorkflows = data[0];
        $scope.Model.parentWorkflow = data[1];
        $scope.Model.currentWorkflow = data[2];
        $scope.Model.availableAccounts = data[3];
        $scope.Model.availableWorkflowTypes = WorkflowType.available();
        $scope.workflowEditorInitialize();
      });

  const loadChecklists = () =>
    checklistsService.getAvailable({ isActive: true }).then((checklists) => {
      $scope.Model.availableChecklists = checklists;
    });

  const loadJobTypes = () =>
    jobTypesService.getAvailable({ isActive: true }).then((jobTypes) => {
      $scope.Model.availableJobTypes = jobTypes;
    });

  const loadMessages = () =>
    messagesService.getAvailable({ type: ['email', 'sms'] }).then((messages) => {
      $scope.Model.availableMessages = messages;
    });

  const loadDocuments = () => {
    documentsService.getAvailable({ isActive: true }).then((documents) => {
      $scope.Model.availableDocuments = documents;
      $scope.Model.availableMergeDocuments = $filter('filter')(documents, (document) => {
        return (
          document.getFileExtension() === 'docx' ||
          (document.getFileExtension() === 'pdf' &&
            document.fields &&
            document.fields.length &&
            document.pdfFields &&
            document.pdfFields.length)
        );
      });
      $scope.Model.availableOtherDocuments = $filter('filter')(documents, (document) => {
        return !_.find($scope.Model.availableMergeDocuments, { id: document.id });
      });
    });
  };

  const initialize = () => {
    loadWorkflowsAndAccounts();
    loadChecklists();
    loadJobTypes();
    loadMessages();
    loadDocuments();
  };

  /*
   * Retrieve Available Workflow Data
   * --------------------------------------------------------------------------------
   */
  if ($rootScope.CurrentAccount.isAdministrator) {
    initialize();
  }

  /*
   * Scope Methods
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = () => {
    if ($scope.Model.completedInitialization) {
      changesService.change();
    }
  };

  const validate = () => {
    return _.get($scope.Model.currentWorkflow, 'name');
  };

  const invalid = () => {
    if ($scope.Model.toState && $scope.Model.toParams) {
      $scope.Model.toState = false;
      $scope.Model.toParams = false;
      const newToState = $scope.Model.toState;
      const newToParams = $scope.Model.toParams;
      return eventService.formWarning({ toState: newToState, toParams: newToParams });
    }
    return uiService.toast({
      text: {
        p1: 'Workflow',
        p2: 'Name',
        p3: 'is required'
      },
      warn: true
    });
  };

  /*
   * Workflow Edit ~ Save Workflow
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const len = $scope.Model.currentWorkflow.stages.length;
    for (let s = 0; s < len; s += 1) {
      delete $scope.Model.currentWorkflow.stages[s].isNew;
      if ($scope.Model.currentWorkflow.stages[s].name === '') {
        $scope.Model.currentWorkflow.stages[s].name = `Stage ${s + 1}`;
      }
      if (Number.isNaN(parseInt($scope.Model.currentWorkflow.stages[s].probability || 0, 10))) {
        $scope.Model.currentWorkflow.stages[s].probability = 100;
      }
      if ($scope.Model.currentWorkflow.stages[s].jobTypes.length) {
        const jLen = $scope.Model.currentWorkflow.stages[s].jobTypes.length;
        for (let j = 0; j < jLen; j += 1) {
          delete $scope.Model.currentWorkflow.stages[s].jobTypes[j].isNew;
        }
      }
      if ($scope.Model.currentWorkflow.stages[s].idMessages.length) {
        const mLen = $scope.Model.currentWorkflow.stages[s].idMessages.length;
        for (let m = 0; m < mLen; m += 1) {
          delete $scope.Model.currentWorkflow.stages[s].idMessages[m].isNew;
        }
      }
      if ($scope.Model.currentWorkflow.stages[s].idDocuments.length) {
        const dLen = $scope.Model.currentWorkflow.stages[s].idDocuments.length;
        for (let d = 0; d < dLen; d += 1) {
          delete $scope.Model.currentWorkflow.stages[s].idDocuments[d].isNew;
        }
      }
    }
    if (!_.get($scope.Model.currentWorkflow, 'id')) {
      return workflowService
        .createWorkflow($scope.Model.currentWorkflow)
        .then(function (result) {
          if (result.status) {
            $scope.Model.currentWorkflow.id = result.id;
            workflowsService.clearCache();
            eventService.credentialsChanged();
            uiService.toast({
              text: {
                p1: 'Workflow details',
                p2: 'saved',
                p3: 'successfully'
              }
            });
          }
        });
    }
    return workflowService.updateWorkflow($scope.Model.currentWorkflow).then(function (result) {
      if (result.status) {
        workflowsService.clearCache();
        eventService.credentialsChanged();
        uiService.toast({
          text: {
            p1: 'Workflow details',
            p2: 'updated',
            p3: 'successfully'
          }
        });
      }
    });
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  changesService.init({ useFinishOnInterval: true });
  changesService.onValidate(validate);
  changesService.onInvalid(invalid);
  changesService.onFinish(saveChanges);
};
